"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_SUBMIT_TX_BULK_ON_ERROR = void 0;
exports.DEFAULT_SUBMIT_TX_BULK_ON_ERROR = 'abort';
